import React from 'react';
import { PageContainer } from '../../../components/common';
import { COMPANY_CONFIG } from '../../../constants/companyConfig';
import './orderReceiptAlternate.css';

const OrderReceiptAlternate = (props) => {
  const {
    selectedProduct,
    selectedAddOnsData,
    serviceAddress,
    userDetails,
    autoPayEnabled,
    paymentMethod,
    subscriberDetails,
    firstname,
    lastname,
    emailId,
    mobileNumber,
    paperlessEnabled = true, // Default to true if not provided
    discount = 0, // Discount amount passed from MultiStepForm
  } = props;

  // Get data from DOM elements if not in props
  const getFromDOM = (elementId) => {
    const element = document.getElementById(elementId);
    const value = element?.textContent?.trim() || element?.value?.trim() || null;
    console.log(`🔍 DOM Check [${elementId}]:`, value);
    return value;
  };

  // Construct user details from props or DOM
  const firstNameFromDOM = getFromDOM('account-first-name');
  const lastNameFromDOM = getFromDOM('account-last-name');
  const orderUserName = getFromDOM('order-user-name');
  const orderPhone = getFromDOM('order-phone');
  const accountPhone = getFromDOM('account-phone');
  
  console.log('🔍 All DOM values:', {
    firstNameFromDOM,
    lastNameFromDOM,
    orderUserName,
    orderPhone,
    accountPhone,
  });
  
  // Check all possible prop names (same pattern as email)
  const userName =
    props.name ||
    props.userName ||
    props.fullName ||
    (props.firstName && props.lastName ? `${props.firstName} ${props.lastName}` : null) ||
    (props.firstname && props.lastname ? `${props.firstname} ${props.lastname}` : null) ||
    userDetails?.name ||
    (firstname && lastname ? `${firstname} ${lastname}` : null) ||
    (subscriberDetails?.firstName && subscriberDetails?.lastName
      ? `${subscriberDetails.firstName} ${subscriberDetails.lastName}`
      : null) ||
    orderUserName ||
    (firstNameFromDOM && lastNameFromDOM ? `${firstNameFromDOM} ${lastNameFromDOM}` : null) ||
      getFromDOM('order-account-name') ||
    'N/A';

  const userPhone =
    props.phone ||
    props.phoneNumber ||
    props.mobileNumber ||
    userDetails?.phone ||
    mobileNumber ||
    subscriberDetails?.phoneNumber ||
    orderPhone ||
    accountPhone ||
   getFromDOM('order-phone') ||
    'N/A';

  const userEmail =
    userDetails?.email ||
    emailId ||
    subscriberDetails?.email ||
    props.email ||
    getFromDOM('order-email') ||
    getFromDOM('account-email') ||
    'N/A';

  const paymentInfo =
    paymentMethod ||
    (autoPayEnabled || props.autoPayValue === 'yes'
      ? 'Auto Pay Enabled'
      : 'Manual Payment');

  console.log('📋 Final OrderReceipt Data:', { userName, userPhone, userEmail, paymentInfo });

  console.log('📋 Computed Values:', {
    userName,
    userPhone,
    userEmail,
    paymentInfo,
  });

  // Get the signin URL based on environment
  const getSignInUrl = () => {
    const env = process.env.REACT_APP_ENV || 'dev';
    return COMPANY_CONFIG.signInUrl(env);
  };

  const getProductPrice = () => {
    return selectedProduct?.price || '0.00';
  };

  // Use discount from props (calculated in MultiStepForm)
  const getDiscount = () => {
    console.log('📋 OrderReceiptAlternate Discount Debug:', {
      discount,
      autoPayEnabled,
      paperlessEnabled,
      props: { discount, autoPayEnabled, paperlessEnabled }
    });
    return discount;
  };

  const calculateTotal = (monthly = false) => {
    const planPrice = parseFloat(getProductPrice());
    const addOnsTotal = selectedAddOnsData?.totalAmount || 0;
    const discountAmount = getDiscount();
    return (planPrice + addOnsTotal - discountAmount).toFixed(2);
  };

  return (
    <PageContainer className="orderReceiptNode-Container">
      <div className="orderReceiptNode-Header">
        <h2>Thank you for your order!</h2>
        <p>We sent your order receipt to your email address.</p>
        <p>
          You can check your order status in your on-line{' '}
          <a href={getSignInUrl()} target="_blank" rel="noopener noreferrer">Subscriber Connect</a> account.
        </p>
      </div>

      <div className="orderReceiptNode-Content">
        {/* Your Account Section */}
        <div className="orderReceiptNode-Section">
          <h3>Your Account</h3>
          <div className="orderReceiptNode-InfoGrid">
            <div className="orderReceiptNode-InfoRow">
              <span className="orderReceiptNode-Label">Name</span>
              <span className="orderReceiptNode-Value">{userName}</span>
            </div>
            <div className="orderReceiptNode-InfoRow">
              <span className="orderReceiptNode-Label">
                Mobile Phone Number
              </span>
              <span className="orderReceiptNode-Value">
                <span className="orderReceiptNode-Verified">✓ Verified</span>
                {userPhone}
              </span>
            </div>
            <div className="orderReceiptNode-InfoRow">
              <span className="orderReceiptNode-Label">Email Address</span>
              <span className="orderReceiptNode-Value">
                <span className="orderReceiptNode-Verified">✓ Verified</span>
                {userEmail}
              </span>
            </div>
            <div className="orderReceiptNode-InfoRow">
              <span className="orderReceiptNode-Label">Service Address</span>
              <span className="orderReceiptNode-Value">
                {serviceAddress?.addressLine1 ||
                  '914 N Purcell Blvd, Pueblo West, CO 81007'}
              </span>
            </div>
          </div>
          <p className="orderReceiptNode-LoginLink">
            Login to your <a href={getSignInUrl()} target="_blank" rel="noopener noreferrer">Subscriber Connect</a> Account
          </p>
        </div>

        {/* Payment Requirement Section */}
        <div className="orderReceiptNode-Section">
          <h3>Payment Requirement</h3>
          <p className="orderReceiptNode-Note">
            All scheduled installations must be paid in full at least 3 days
            before the installation date. This includes any installation
            charges.
          </p>
          <table className="orderReceiptNode-Table">
            <thead>
              <tr>
                <th>Category</th>
                <th>Details</th>
                <th className="price-col">Cost (Before Installation)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Internet Services</td>
                <td>{selectedProduct?.description || 'High-speed internet'}</td>
                <td className="price-col">${getProductPrice()}</td>
              </tr>
              {selectedAddOnsData?.selectedAddOns?.map((addon) => (
                <tr key={addon.id}>
                  <td>{addon.title}</td>
                  <td>Add-Ons</td>
                  <td className="price-col">{addon.price}</td>
                </tr>
              ))}
              {getDiscount() > 0 && (
                <tr>
                  <td>Discounts</td>
                  <td>AutoPay & Paperless Billing</td>
                  <td className="price-col" style={{ color: 'green' }}>-${getDiscount().toFixed(2)}</td>
                </tr>
              )}
              <tr className="orderReceiptNode-TotalRow">
                <td
                  colSpan="2"
                  style={{ textAlign: 'right', fontWeight: 'bold' }}
                >
           
                </td>
                <td className="price-col" style={{ fontWeight: 'bold' }}>  Total: ${calculateTotal()}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Monthly Recharge Amount Section */}
        <div className="orderReceiptNode-Section">
          <h3>Monthly Recharge Amount</h3>
          <table className="orderReceiptNode-Table">
            <thead>
              <tr>
                <th>Category</th>
                <th>Details</th>
                <th className="price-col">Cost (Monthly)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Internet Services</td>
                <td>{selectedProduct?.description || 'High-speed internet'}</td>
                <td className="price-col">${getProductPrice()}</td>
              </tr>
              {selectedAddOnsData?.selectedAddOns?.map((addon) => (
                <tr key={addon.id}>
                  <td>{addon.title}</td>
                  <td>Add-Ons</td>
                  <td className="price-col">{addon.price}</td>
                </tr>
              ))}
              {getDiscount() > 0 && (
                <tr>
                  <td>Discounts</td>
                  <td>AutoPay & Paperless Billing</td>
                  <td className="price-col" style={{ color: 'green' }}>-${getDiscount().toFixed(2)}</td>
                </tr>
              )}
              <tr className="orderReceiptNode-TotalRow">
                <td
                  colSpan="2"
                  style={{ textAlign: 'right', fontWeight: 'bold' }}
                >
                
                </td>
                <td className="price-col" style={{ fontWeight: 'bold' }}>  Total: ${calculateTotal()}/mo</td>
              </tr>
            </tbody>
          </table>
          <div className="orderReceiptNode-ValidityInfo">
            <p>
              <strong>Validity Period:</strong> 30 days from recharge
            </p>
            <p>
              <strong>Recharge Date:</strong> On or before service start date
            </p>
            <p className="orderReceiptNode-WarningNote">
              * If your account balance is insufficient or not recharged before
              the validity period ends, your service may be suspended until the
              next successful recharge.
            </p>
            {getDiscount() > 0 && (
              <div className="orderReceiptNode-DiscountNote" style={{ 
                backgroundColor: '#e8f5e8', 
                padding: '12px', 
                borderRadius: '8px', 
                color: '#2d5a2d', 
                marginTop: '12px' 
              }}>
                <p style={{ margin: 0, fontWeight: 'bold' }}>
                  {autoPayEnabled && paperlessEnabled ? (
                    <>✓ You're saving ${getDiscount().toFixed(2)}/month with AutoPay and Paperless Billing discounts</>
                  ) : autoPayEnabled ? (
                    <>✓ You're saving ${Math.min(getDiscount(), 5).toFixed(2)}/month with AutoPay discount</>
                  ) : paperlessEnabled ? (
                    <>✓ You're saving ${Math.min(getDiscount(), 5).toFixed(2)}/month with Paperless Billing discount</>
                  ) : null}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Recharge Preferences Section */}
        <div className="orderReceiptNode-Section">
          <h3>Recharge Preferences</h3>
          <div className="orderReceiptNode-InfoGrid">
            <div className="orderReceiptNode-InfoRow">
              <span className="orderReceiptNode-Label">Automatic Payment</span>
              <span className="orderReceiptNode-Value">{paymentInfo}</span>
            </div>
            <div className="orderReceiptNode-InfoRow">
              <span className="orderReceiptNode-Label">Recharge receipt</span>
              <span className="orderReceiptNode-Value">{userEmail}</span>
            </div>
          </div>
        </div>

        {/* Email Confirmation */}
        <div className="orderReceiptNode-EmailConfirmation">
          <span>📧</span> We'll send a copy of this to {userEmail}.
        </div>
      </div>
    </PageContainer>
  );
};

export default OrderReceiptAlternate;
